"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsComponent = SearchResultsComponent;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const pagination_1 = require("@genesys/client-core/lib/pagination");
const screen_amount_profile_1 = require("@genesys/client-core/lib/screen-amount-profile");
const property_1 = require("@genesys/property");
const React = __importStar(require("react"));
const Actions = __importStar(require("../../actions"));
const functions_1 = require("../functions");
function SearchResultsComponent(props) {
    return props.error ? (React.createElement("p", null, props.error)) : (React.createElement(screen_amount_profile_1.ScreenAmountProfile, null, ({ getAmountFormat }) => (React.createElement("div", null,
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(Exporter.XlsxSingleSheetExport, { data: props.generateCsvData(), filename: "products" }, (onClick) => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download"))))),
        React.createElement(pagination_1.PaginationComponent, Object.assign({}, props.pagination)),
        React.createElement(Elements.DataPresenterTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    [
                        {
                            title: "GenesysNo",
                            name: "genesysNo"
                        },
                        {
                            title: "OwnerUsername",
                            name: "ownerUsername"
                        },
                        {
                            title: "OwnerName",
                            name: "ownerName"
                        },
                        {
                            title: "LastModifiedBy",
                            name: "lastModifiedBy"
                        },
                        {
                            title: "SystemStatus",
                            name: "systemStatus"
                        },
                        {
                            title: "PriceDate",
                            name: "priceDate"
                        },
                        {
                            title: "StatusDate",
                            name: "statusDate"
                        },
                        {
                            title: "ProductId",
                            name: "productId"
                        }
                    ].map((property) => (React.createElement("th", { key: property.name, onClick: () => props.dispatch(Actions.setSortColumn(property.name)) }, property.title))),
                    props.properties.map((propertyName) => {
                        return (React.createElement("th", { key: propertyName },
                            React.createElement("span", { onClick: () => {
                                    props.dispatch(Actions.setResultPropertySortColumn(propertyName));
                                } }, propertyName),
                            (0, functions_1.getAmountFormatSelector)(props.productId, "Property", getAmountFormat, props.results.map((x) => property_1.PropertyValueSet.fromString(x.properties)), propertyName)));
                    }),
                    props.resultProperties.map((propertyName) => (React.createElement("th", { key: propertyName },
                        React.createElement("span", { onClick: () => props.dispatch(Actions.setResultPropertySortColumn(propertyName)) }, propertyName),
                        (0, functions_1.getAmountFormatSelector)(props.productId, "Result", getAmountFormat, props.results.flatMap((x) => x.operatingCaseResults.map((y) => property_1.PropertyValueSet.fromString(y.result))), propertyName)))))),
            React.createElement("tbody", null, props.results.map((row, i) => {
                const properties = property_1.PropertyValueSet.fromString(row.properties);
                const caseResults = row.operatingCaseResults.map((results) => ({
                    sortNo: results.sortNo,
                    caseName: results.caseName,
                    result: property_1.PropertyValueSet.fromString(results.result)
                }));
                return (React.createElement("tr", { key: i },
                    React.createElement("td", null,
                        props.genesysNumberPrefix,
                        row.genesysNo,
                        "-",
                        row.revisionNo),
                    React.createElement("td", null, row.ownerUserName),
                    React.createElement("td", null, row.ownerName),
                    React.createElement("td", null, row.lastModifiedBy),
                    React.createElement("td", null, row.systemStatus),
                    React.createElement("td", null, row.priceDate),
                    React.createElement("td", null, row.statusDate),
                    React.createElement("td", null, row.productId),
                    props.properties.map((propertyName) => (React.createElement("td", { key: propertyName }, (0, functions_1.getPropertyValue)(props.productId, "Property", propertyName, getAmountFormat, property_1.PropertyValueSet.get(propertyName, properties))))),
                    props.resultProperties.map((propertyName) => (React.createElement("td", { key: propertyName },
                        React.createElement("table", null,
                            React.createElement("tbody", null, caseResults
                                .sort((a, b) => a.sortNo - b.sortNo)
                                .filter((caseResult) => property_1.PropertyValueSet.hasProperty(propertyName, caseResult.result))
                                .map((caseResult) => {
                                const propertyValue = property_1.PropertyValueSet.get(propertyName, caseResult.result);
                                return (React.createElement("tr", { key: `${caseResult.sortNo}:${caseResult.caseName}` },
                                    React.createElement("th", null, `${caseResult.caseName}`),
                                    React.createElement("td", null, (0, functions_1.getPropertyValue)(props.productId, "Result", propertyName, getAmountFormat, propertyValue))));
                            }))))))));
            })))))));
}
//# sourceMappingURL=search-results-component.js.map